import { Group } from "@mantine/core"
import { SuperAdminVenueTabs } from "src/components/superadmin/venues/SuperAdminVenueTabs"
import { EditSuperAdminVenueAction } from "src/components/superadmin/venues/SuperAdminVenueActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { SuperAdminVenueView } from "src/components/superadmin/venues/SuperAdminVenueView"

export function SuperAdminVenue() {

    const { currentItem } = useAppState(state=>state.tenants)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminVenueAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminVenueTabs/>
            <SuperAdminVenueView/>
            
        </PageLayout>
    )

}